import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/auth'
import contract from '@/store/contract'
import template from '@/store/template'
import emailTemplate from '@/store/emailTemplate'
import style from '@/store/style'
import invoice from '@/store/invoice'
import finance from '@/store/finance'
import user from '@/store/user'
import notification from '@/store/notification'
import createLogger from 'vuex/dist/logger'
import common from "@/api/common";

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breadcrumbsItems: [],
    currencyValues: {
      usd_to_uah: 0.0,
      eur_to_uah: 0.0
    }
  },
  getters: {
    breadcrumbsItems(state) {
      return state.breadcrumbsItems
    },
    templateTypesSelector() {
      return [
        {text: 'Invoice', value: 0},
        {text: 'Technical task', value: 1},
        {text: 'Act', value: 2}
      ]
    },
    currencyValues(state) {
      return state.currencyValues
    }
  },
  mutations: {
    updateBreadcrumbsItems(state, { items }) {
      state.breadcrumbsItems = items
    },
    updateCurrencyValues(state, { payload }) {
      state.currencyValues = payload
    }
  },
  actions: {
    async getDictionary(_, payload) {
      return await common.getDictionary(payload.name)
    },
    async getBanks() {
      return await common.getBanks()
    },
    async getPaymentCategories(_, payload) {
      return await common.getPaymentCategories(payload.limit, payload.offset, payload.paymentType)
    },
    async getConstants(_, payload) {
      return await common.getSystemConstants(payload.name)
    },
    async getDashboardChart(_, payload) {
      return await common.getDashboardChart(payload.scope, payload.currency, payload.chartType, payload.paymentType, payload.period, payload.step)
    },
    async updateCurrencyValues({commit}) {
        await common.getSystemConstants('usd_to_uah,eur_to_uah')
          .then(response => {
              switch (response.status) {
                  case 200:
                      commit('updateCurrencyValues', {payload: response.data})
              }
          })
    }
  },
  modules: {
    auth,
    contract,
    template,
    emailTemplate,
    style,
    invoice,
    user,
    finance,
    notification
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
